import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const itemCart = []
const visitedItem = []
const unions = []
const store = new Vuex.Store({
  state: {
    union: { id: 1 },
    unions: unions,
    itemCart: itemCart,
    visitedItem: visitedItem,
    user: { id: -1, name: '' },
    status: 0
  },
  getters: {
    unionId: state => {
      return state.union.id
    },
    getStatus: state => {
      return state.status
    },
    getItemById: state => itemId => {
      return state.itemCart.filter(tmpItem => tmpItem.id === itemId)
    },
    getVisitedItems: state => {
      return state.visitedItem
    },
    itemCart: (state) => {
      return state.itemCart
    },
    userInfo: (state) => {
      return state.user
    },
    cartNum: (state) => {
      var num = 0
      state.itemCart.forEach(item => {
        num += item.num
      })
      return num
    },
    unions: (state) => {
      return state.unions
    }
  },
  mutations: {
    setUnionId: (state, UnionId) => {
      state.union.id = UnionId
    },
    changeStatus: (state, status) => {
      state.status = status
    },
    changeUnion: (state, union) => {
      state.union = union
      store.dispatch('changeUnion', union.id)
      console.log('++++++changeUnion', state.union, union)
    },
    addTocart: (state, item) => {
      // 添加到购物车
      console.log(item.num, 'in num')
      const itemcart = state.itemCart.filter(itemNow => itemNow.id === item.id)
      console.log(itemcart, 'itemcart')
      if (itemcart.length === 0) {
        console.log('[]')
        state.itemCart.push(item)
      } else {
        state.itemCart.forEach(itemNow => {
          if (itemNow.id === item.id) {
            itemNow.num = item.num || itemNow.num
          }
        })
      }
      console.log(state, item, 'state.itemCart')
      store.dispatch('addToCart', item)
    },
    getCartItems: (state, item) => {
      state.itemCart.push(item)
      return state.itemCart
    },
    addVisitedItem: (state, itemId) => {
      var item = state.visitedItem.filter(tmpItemId => tmpItemId === itemId)
      if (item.length === 0) {
        state.visitedItem.push(itemId)
      } else {
        return
      }
    },
    removeMany: (state, itemIds) => {
      // 删除多个
      itemIds.forEach(itemId => {
        state.itemCart = state.itemCart.filter(item => item.id !== itemId)
      })
      console.log(state.itemCart, 'item after delete')
      store.dispatch('removeItems', itemIds)
    },
    removeItem: (state, itemId) => {
      // 删除一个
      console.log(itemId)
      state.itemCart = state.itemCart.filter(item => item.id !== itemId)
      console.log(state.itemCart, 'item after delete')
      store.dispatch('removeItems', [itemId])
    },
    clearCart: (state) => {
      // 清空购物车
      state.itemCart = []
      console.log(state.items, 'item after clear')
      store.dispatch('clearCart')
    },
    saveUserInfo: (state, user) => {
      state.user = user
    },
    getUnions: (state, union) => {
      state.unions = union
      console.log(state.unions)
    }
  },
  actions: {
    addToCart (content, item) {
      var axios = this._vm.$axios
      const url = '/hy-sb-item/purchaseShopCart/add'
      const data = [{
        quantity: item.num,
        itemId: item.id
      }]
      axios({
        url: url,
        data: data,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        method: 'post'
      }).then((response) => {
        console.log('添加购物车')
      })
    },
    removeItems (context, itemIds) {
      var axios = this._vm.$axios
      console.log(itemIds, 'itemids')
      const data = []
      itemIds.forEach(itemId => {
        data.push({ itemId: itemId })
      })
      axios({
        url: '/hy-sb-item/purchaseShopCart/delete',
        data: data,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        method: 'post'
      }).then((response) => {
        console.log('删除购物车')
      })
    },
    reloadUserInfo () {
      var axios = this._vm.$axios
      const url = '/hy-sb-userinfo/user/getUserInfo' + '?id=' + Math.random()
      axios.get(url).then((response) => {
        var user = {}
        var tmpUnionId = ''
        const { content = {}} = response
        const { shop: { name }} = content;
        ({ unionId: tmpUnionId, id: user.id, loginName: user.loginName, phone: user.phone } = content)
        user.shopName = name
        this.commit('setUnionId', tmpUnionId)
        this.commit('saveUserInfo', user)
        if (user.id !== -1) {
          this.dispatch('reloadItems')
          this.dispatch('getUnions')
        }
      })
    },
    getUnions () {
      var axios = this._vm.$axios
      const url = '/hy-sb-system/wordlib/findType'
      var data = {
        params: { type: '联盟类型' }
      }
      axios.get(url, data).then(response => {
        console.log('++++++response', response)
        const { content = {}} = response
        const tmpUnions = []
        if (content[0].type === '联盟类型') {
          content.forEach(union => {
            console.log('union_____', union)
            var temUnion = {};
            ({ code: temUnion.id, value: temUnion.name } = union)
            tmpUnions.push(temUnion)
          })
          this.commit('getUnions', tmpUnions)
        }
      })
    },
    reloadItems () {
      var axios = this._vm.$axios
      const url = '/hy-sb-item/purchaseShopCart/items'
      axios.get(url).then((response) => {
        const { content = [] } = response
        console.log(content, 'content')
        content.forEach(item => {
          var tmpItem = {}
          if (item.imgs === null || item.imgs === undefined) {
            item.imgs = []
          }
          ({ itemId: tmpItem.id, quantity: tmpItem.num, itemShopId: tmpItem.shopId, itemShopName: tmpItem.shopName,
            title1: tmpItem.name, imgs: [tmpItem.image, ...tmpItem.otherImg], calcuPrice: tmpItem.oldPrice,
            title2: tmpItem.norm, manufacturer: tmpItem.manufacture, transferPrice: tmpItem.price } = item)
          if (tmpItem.image === undefined) tmpItem.image = 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/filenZpmQSDwtJ.jpg-ly.jpg'
          if (!tmpItem.price) { tmpItem.price = tmpItem.oldPrice }
          this.commit('getCartItems', tmpItem)
        })
      })
    },
    clearCart () {
      var axios = this._vm.$axios
      const url = '/hy-sb-item/purchaseShopCart/emptyShopCart'
      axios.get(url).then((response) => {
        console.log('清空购物车')
      })
    },
    changeUnion (context, id) {
      console.log(id)
      var data = {
        unionId: id
      }
      var axios = this._vm.$axios
      const url = '/hy-sb-userinfo/user/changeUnion'
      axios.post(url, data).then((response) => {
        console.log(response)
        location.reload()
      })
    }
  }
})
export default store
